import type { IFilterableListItem, IOmit, ISelectProps } from '@sixui/ui';
import { forwardRef } from 'react';
import { Select } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

export type IOrganizationRoleSelectorProps = IOmit<ISelectProps, 'items'>;

export const OrganizationRoleSelector = forwardRef<
  HTMLDivElement,
  IOrganizationRoleSelectorProps
>(function OrganizationRoleSelector(props, forwardedRef) {
  const { ...other } = props;
  const { t } = useTranslation();
  const items: Array<IFilterableListItem> = [
    {
      value: 'member',
      label: t('OrganizationRoleSelector.member.label'),
      supportingText: t('OrganizationRoleSelector.member.supportingText'),
    },
    {
      value: 'admin',
      label: t('OrganizationRoleSelector.admin.label'),
      supportingText: t('OrganizationRoleSelector.admin.supportingText'),
    },
    {
      value: 'owner',
      label: t('OrganizationRoleSelector.owner.label'),
      supportingText: t('OrganizationRoleSelector.owner.supportingText'),
    },
  ];

  return <Select {...other} items={items} ref={forwardedRef} />;
});
